import { Box, Typography, Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { IBrandExpert } from './constants';
import { ExpertList } from './ExpertList';
import { SearchExpert } from './SearchExpert';
import { DotLottleLoader, LoadMoreBtn } from '../../../../components/Loader';
import { PageTitle } from '../../../../components/PageTitle';
import { WhiteBackground } from '../../../../components/WhiteBackground';
import { NoDataView } from '../../../../components/EmptyPanel/NoDataView';
import { IconUser, IconPlus } from '../../../../utils/icons';
import { useUser } from '../../../../hooks/useUser';
import { isBrand, isRMN } from '../../../../utils';
import { usePortalPath } from '../../../../hooks/usePortalPath'

interface IExpertList {
  experts: Array<IBrandExpert>;
  loading?: boolean;
  loadMore?: any;
  count: number;
  isFeatured?: boolean;
}

export function ExpertListingView({
  count,
  experts,
  loading,
  loadMore,
  isFeatured = false,
}: IExpertList) {
  const navigate = useNavigate();
  const { p } = usePortalPath();
  const { user, role } = useUser();

  const showLoader = (condition?: boolean) => {
    if (condition) return <DotLottleLoader />;
    return null;
  };

  const handleNewOrder = () => {
    navigate(p('/video-production/orders?create=new'));
  };

  return (
    <WhiteBackground>
      <PageTitle title={isFeatured ? "Featured Experts" : "My Experts"} />
      <Box className="flex flex-col gap-8 mt-10">
        {!isFeatured && <SearchExpert />}
        <Box className="flex gap-0">
          <Typography className="text-text-2 w-[110px]">
            {count} Experts
          </Typography>
          <div className="mt-3 border-t w-full border-border-token" />
        </Box>
      </Box>
      {showLoader(!count && loading)}
      {experts.length > 0 ? (
        <Box className="mt-10">
          <ExpertList experts={experts} />
          {loadMore && <LoadMoreBtn onClick={loadMore} loading={loading} />}
        </Box>
      ) : (
        <NoDataView
          showTextInline
          Icon={IconUser}
          subText={
            isFeatured
              ? "Experts will be visible once it will be marked as featured."
              : "Experts will be visible once you have projects and videos. Create a project to get started!"
          }
        >
          {!isFeatured && (
            <Button
              onClick={handleNewOrder}
              variant="contained"
              sx={{
                backgroundColor: 'var(--accent)',
                color: '#fff',
                borderRadius: '12px',
                padding: '12px 24px 12px 20px',
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 500,
                '&:hover': {
                  // darker-gold hover: no token expresses it (--accent-dark is lighter)
                  backgroundColor: '#8B6F3A',
                },
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <IconPlus width={20} height={20} stroke="#fff" />
              {isBrand(role) || isRMN(user) ? 'Request A Quote' : 'New Order'}
            </Button>
          )}
        </NoDataView>
      )}
    </WhiteBackground>
  );
}
